export function getUserAvatar(user: { image?: string | null }): string {
  const { image } = user
  if (!image) {
    return 'https://webcontent.attensi.com/images/defaults/avatar-anonymous.svg'
  }

  return image
}
